export const POINTER_DOWN = window.PointerEvent ? ['pointerdown'] : ['mousedown', 'touchstart'];
export const POINTER_MOVE = window.PointerEvent ? ['pointermove'] : ['mousemove', 'touchmove'];
export const POINTER_UP = window.PointerEvent ? ['pointerup'] : ['mouseup', 'touchend'];

export const GAME_READY = 'GAME_READY';
export const PLAY = 'PLAY';
export const PLAY_NOT_READY = 'PLAY_NOT_READY';
